/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { UniversalTrackerValueView } from '@features/universal-tracker-value';
import { ColumnCommonProps } from '@g17eco/types/survey-question-list';
import { Column } from '@g17eco/molecules/tracking-list';

export const ColumnValue = (props: ColumnCommonProps) => {
  const { question, unitConfig } = props;

  if (!question.utrv) {
    return null;
  }

  return (
    <Column className='d-none d-md-inline-block valueCol'>
      <UniversalTrackerValueView
        utr={question.universalTracker.getRaw()}
        utrv={question.utrv}
        valueType={question.valueType}
        unitConfig={unitConfig}
      />
    </Column>
  );
}
